<template>
    <page-container>
        <div class="active_bar">
            <a-button type="primary" @click="handleAddStation">
                <i class="el-icon-plus"></i>
                新增站点</a-button
            >
        </div>
        <a-table
            :columns="STATIONCOLUMN"
            :data-source="dataList"
            :row-key="(rec, index) => index"
            class="table-multip"
            :loading="loading"
            :scroll="{ x: 'calc(700px + 50%)' }"
            :pagination="pagination"
            @change="tableChange"
        >
            <template slot="stationAddress" slot-scope="text">
                <a-tooltip>
                    <template slot="title">
                        {{ text }}
                    </template>
                    <div class="ellipsis2">{{ text }}</div>
                </a-tooltip>
            </template>
            <template slot="stationLoc" slot-scope="text">
                <a-tooltip>
                    <template slot="title">
                        {{ text }}
                    </template>
                    <div class="ellipsis2">{{ text }}</div>
                </a-tooltip>
            </template>
            <template slot="action" slot-scope="text, record">
                <a-button class="active_btn" type="link" @click="handleEditLog(record)">修改日志</a-button>
                <a-button class="active_btn" type="link" @click="handleEdit(record)">编辑</a-button>
                <a-button class="active_btn delete_btn" type="link" @click="onDelete(record)">删除</a-button>
            </template>
        </a-table>
        <editStationDialog ref="editStationDialog" @refresh="handleRefresh" />
        <EditLogModal ref="editLogModalRef" type="station" />
    </page-container>
</template>

<script>
import PageContainer from '@/components/page-contanier/index.vue';
import store from '@/store/index';
import { setAppToken, setAppClientCode } from '@/utils/auth';
import { STATIONCOLUMN } from '../const';
import { getSelectStation, deleteStation } from '../../api';
import editStationDialog from './editStationDialog.vue';
import EditLogModal from './EditLogModal'; // 编辑日志的对话框

export default {
    name: 'StationList',
    components: {
        PageContainer,
        editStationDialog,
        EditLogModal
    },
    data() {
        return {
            STATIONCOLUMN,
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.pageSize = pageSize;
                },
                showQuickJumper: true,
                showTotal: (total) => `共 ${total} 条`
            },
            dataList: [],
            loading: false
        };
    },
    created() {
        if (this.$route.path === '/smartWiring') {
            const { appToken, appClientCode, accountName, accountId, mobile, customerCode } = this.$route.query;
            if (appToken) {
                setAppToken(appToken);
            }
            if (appClientCode) {
                setAppClientCode(appClientCode);
                this.appClientCode = appClientCode;
            }
            if (accountId) {
                store.commit('user/SET_ACCOUNTID', accountId); // 账号id
            }
            if (accountName) {
                store.commit('user/SET_ACCOUNTNAME', accountName); // 组织名称
            }
            if (mobile) {
                store.commit('user/SET_MOBILE', mobile); // 组织名称
            }
            if (customerCode) {
                store.commit('user/SET_CUSTOMER_CODE', customerCode); // 货主编码
            }
        }
        this.getList();
    },
    methods: {
        async getList() {
            const { current, pageSize } = this.pagination;
            this.loading = true;
            try {
                const res = await getSelectStation({
                    customerCode: this.$store.state.user.customerCode,
                    size: pageSize,
                    num: current - 1
                });
                this.dataList = res.data || [];
                this.pagination.total = res.total || 0;
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        tableChange(pagination) {
            let { current } = pagination;
            if (pagination.pageSize !== this.pagination.pageSize) {
                current = 1;
            }
            this.pagination = {
                ...pagination,
                current
            };
            this.getList();
        },
        handleAddStation() {
            this.$refs.editStationDialog.show();
        },
        handleEdit(row) {
            this.$refs.editStationDialog.show(row);
        },
        onDelete(row) {
            this.$confirm({
                content: '确认删除该站点？',
                okText: '删 除',
                okType: 'danger',
                class: 'delete_bar',
                icon: () =>
                    this.$createElement('a-icon', {
                        props: {
                            type: 'info-circle',
                            theme: 'filled'
                        }
                    }),
                cancelText: '取消',
                onOk: async () => {
                    await deleteStation([row.stationId]);
                    this.$message.success('删除成功');
                    this.handleRefresh();
                }
            });
        },
        handleRefresh() {
            this.getList();
        },
        // 修改日志
        handleEditLog(data) {
            this.$refs.editLogModalRef.openModal(data);
        }
    }
};
</script>

<style lang="less" scoped>
.active_bar {
    margin-bottom: 24px;
}
.search_bar {
    border-bottom: 1px solid #ebedf0;
}
.line_list {
    padding: 0 24px;
}
.active_btn {
    padding: 0;
    margin: 0;
    &::after {
        content: '';
        width: 1px;
        height: 12px;
        background-color: #dcdee0;
        display: inline-block;
        margin: 0 8px;
    }
}
.active_btn:last-child::after {
    display: none;
}
.delete_btn {
    color: #969799;
}
.el-icon-plus {
    margin-right: 8px;
}
</style>
<style lang="less">
.delete_bar {
    .ant-modal-confirm-body {
        color: #323232;
        .anticon {
            margin-right: 8px;
        }
        .ant-modal-confirm-content {
            color: #323232 !important;
        }
    }
}
</style>
